import React from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { Link } from "react-router-dom";
import { charLimit } from "../../../../utils/commonHelper";
import { getTimeDifference } from "../../../../utils/dateTimeFormat";
import { grp_member1, img_placehlder } from "../../../../assets";
import { IoChatboxEllipsesOutline } from "react-icons/io5";
import { HiOutlineUserGroup } from "react-icons/hi";
import { MdKeyboardArrowRight } from "react-icons/md";
import CustomModal from "../../../../components/modals/CustomModal";

const MemberListModal = ({ memberList, setPage, total, show, handleClose }) => {
  // console.log(memberList[0]?._user?._id, "memberList MOdal");
  return (
    <CustomModal
      show={show}
      handleClose={handleClose}
      className={"member_list_modal"}
      size={"lg"}
    >
      <InfiniteScroll
        dataLength={memberList?.length || 0}
        next={() => setPage((prev) => prev + 1)}
        hasMore={memberList?.length < total}
        // endMessage={<p style={{ textAlign: "center" }}></p>}
      >
        <div className="group_member_list">
          <h3 className="text-center">Members List</h3>
          <ul>
            {memberList?.map((data) => (
              <li key={data?._user?._id}>
                <Link
                  to={`/dashboard/group/groupRequestDrawer/Send_Msg_Req/${data?._user?._id}`}
                ></Link>
                <img
                  src={data?._user?.profilePicture || img_placehlder}
                  alt="Group Cover"
                />
                {/* {data} */}

                <p>{data?._user?.fullName}</p>
              </li>
            ))}
          </ul>
        </div>
      </InfiniteScroll>
    </CustomModal>
  );
};

export default MemberListModal;
